import { IAutomationObject } from '../../types'

export interface IDoor extends IAutomationObject {
    isOpen: boolean;
    isOpenAlarm: boolean;
    errDelay: number;
    overridden: boolean;
    outOfService: boolean;

    onValueChanged: any;

}

export const schema = 'AutomationApps.Devices.Sensors.Door';
export const modelId = 'dtmi:AutomationApps:Devices:Sensors:Door';
